export default "__VITE_ASSET__5fd80da4__"